module.exports = __webpack_public_path__ + "static/icons/icon-construccon.9b229e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-construccon.svg
// module id = Kl5O
// module chunks = 1